import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IGroup } from '../types/IGroup';
import { Request } from './Request';

export interface IGetGroupsParams extends IGetItemsParams {
}

export interface IGetGroupsResult extends IGetItemsResult {
  groups: IGroup[];
}

export class GetGroupsRequest extends Request<IGetGroupsParams, IGetGroupsResult> {
  constructor(params: IGetGroupsParams) {
    super('getGroups', params);
  }
}
